module.exports = __webpack_public_path__ + "img/license_image6.c3fdad86.png";